<!--日期選擇器
    last modi
    {
      date:20190924
      modi:Chuante
    }

-->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-flex>
        <v-dialog
                eager
                v-if="this.editType!='menu'"
                v-model="menuEditDate"
                :close-on-content-click="false"
                :disabled="disabled"
                width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                        v-model="procDate"
                        :label="dateTitle"
                        :hint="editHint"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-on="on"
                        :clearable="clearable"
                        return-masked-value
                        :mask="maskStr"
                        @keyup="dateKeyChange"
                        :disabled="disabled"
                        style="max-width: 160px"
                ></v-text-field>
            </template>
            <v-date-picker   :day-format="dayFormatCustom" locale="zh-tw" :disabled="disabled" v-model="editDatePick" no-title  scrollable @input="menuEditDate = false" :type="dateType" :allowed-dates="allowDates"></v-date-picker>
        </v-dialog>

        <v-menu
                v-if="editType=='menu'"
                v-model="menuEditDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                :disabled="disabled"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                        v-on="on"
                        v-model="procDate"
                        :label="dateTitle"
                        :hint="editHint"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        :clearable="clearable"
                        return-masked-value
                        @keyup="dateKeyChange"
                        :disabled="disabled"
                        :mask="maskStr"
                        style="max-width: 160px"
                ></v-text-field>
                <!--@change="dateChange"-->

            </template>
            <v-date-picker   :day-format="dayFormatCustom" locale="zh-tw" :disabled="disabled" v-model="editDatePick" no-title scrollable @input="menuEditDate = false" :type="dateType" :allowed-dates="allowDates"></v-date-picker>
        </v-menu>
    </v-flex>
</template>

<script>
    export default {
        name: "HismaxDatePicker",
        props:{
            editType:  //預設為menu開啟，若為其它名稱(如diaglog)則使用diaglog開啟
                {
                    default:'dialog',
                    type:String,
                },
            dateTitle:String, //輸入框說明的文字內容
            editHint:String, //呈現在text-field下方的提示文字
            editDate:{  //呈現在text-field上的日期
                default:'',
                type:String,
            },
            editDisabled: // disabled屬性
                {
                    default:false,
                    type:Boolean,
                },
            clearable:Boolean, //是否有清除鈕
            dateType:String,//不給 預設為"日"，dateType='month' 為"月"
            isRocType: //民國年或西元年  true-> 民國年 (西元年-1911)  false ->西元年 (預設)
                {
                    default:false,
                    type:Boolean,
                },
            allowDates:
                {
                    type:Function,
                    default: () => true,
                },
        },

        data() {
            return {
                //處裡元件內呈現的日期
                procDate:'',
                //是否開始日器選擇窗
                menuEditDate: false,
                //日期選擇窗選擇的日期
                editDatePick : '',
                //disabled屬性
                disabled:false,
                //防呆用遮照
                maskStr:'####-##-##',

            }
        },
        created(){

            if(this.isRocType==true)
            {
                var datePool = [];
                let rocDate = '';
                datePool =  this.editDate.split('-');

                let YYY = Number(datePool[0]) - 1911;
                let mm = datePool[1];
                if(this.dateType=='month')
                {
                    rocDate = YYY + '-' + mm ;
                }else {
                    let dd = datePool[2];
                    rocDate = YYY + '-' + mm + '-' + dd;
                }
                this.procDate = rocDate;

            }
            else {
                this.procDate = this.editDate;
            }

            if(this.isRocType==true)
            {
                this.maskStr = (this.dateType == 'month') ? '###-##' : '###-##-##';
            }
            else {
                if(this.dateType=='year'){
                    this.maskStr =='####'
                }else {
                    this.maskStr = (this.dateType == 'month') ? '####-##' : '####-##-##';
                }

            }
        },
        watch: {

            editDisabled(nVal)
            {
                if(nVal)
                {
                    this.disabled = true;
                }
                else
                {
                    this.disabled = false;
                }

            },

            editDate(nVal)
            {
                if(nVal!= this.procDate)
                {
                    this.setProcDate();
                }
            },

            procDate(nVal,oVal){

                if(nVal != oVal)
                {
                    if(this.isRocType==true)
                    {
                        this.maskStr = (this.dateType == 'month') ? '###-##' : '###-##-##';
                    }
                    else {
                        if(this.dateType=='year'){
                            this.maskStr =='####'
                        }else {
                            this.maskStr = (this.dateType == 'month') ? '####-##' : '####-##-##';
                        }
                    }

                    this.$emit('datePick', nVal);
                }


            },

            editDatePick(){
                this.$emit('datePick', this.editDatePick);
            },


        },

        computed:{

        },
        methods: {

            // formatDate (date) {
            //   if (!date) return null;
            //
            //   const [year, month, day] = date.split('-')
            //   return `${year}-${month}-${day}`
            // },

            // parseDate (date) {
            //   if (!date) return null;
            //
            //   const [year, month, day] = date.split('-')
            //   return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            // },

            dateKeyChange(){
                this.menuEditDate = false;
            },

            dateBlur(){
                //   this.editDatePick = this.procDate;
            },

            setProcDate(){
                if(this.isRocType==true)
                {
                    let datePool = this.editDate.split('-');
                    let YYY = Number(datePool[0]) -1911;
                    let mm = datePool[1];
                    let dd = datePool[2];
                    let rocDate = YYY + '-' + mm + '-' + dd;
                    // console.log(rocDate);
                    this.procDate = rocDate;
                }
                else {
                    this.procDate = this.editDate;
                }
            },

            dayFormatCustom(item){
                // console.log(item)
                let date = new Date(item);
                return date.getDate();
            },


        },
    }
</script>

<style scoped>

</style>